"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalQrContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var qrcode_react_1 = require("qrcode.react");
var material_1 = require("@mui/material");
var react_toastify_1 = require("react-toastify");
var react_1 = require("react");
var ButtomComponent_1 = __importDefault(require("../../components/Form/ButtomComponent"));
var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};
function ModalQrContainer(_a) {
    var disclosure = _a.disclosure, url = _a.url, client = _a.client;
    var downloadRef = (0, react_1.useRef)(null);
    function handleCopyUrlQr() {
        navigator.clipboard.writeText(url);
        react_toastify_1.toast.success('Copiado al portapapeles');
    }
    var downloadQR = function () {
        var _a, _b, _c, _d;
        var canvas = document.getElementById('ValeQrcode');
        var pngUrl = canvas === null || canvas === void 0 ? void 0 : canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
        var downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = "".concat((_a = client.first_name) !== null && _a !== void 0 ? _a : '', " ").concat((_b = client.second_name) !== null && _b !== void 0 ? _b : '', " ").concat((_c = client.first_last_name) !== null && _c !== void 0 ? _c : '', " ").concat((_d = client.second_last_name) !== null && _d !== void 0 ? _d : '', "-QR.png");
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Modal, __assign({ open: disclosure.isOpen, onClose: disclosure.onClose }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: style }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                        height: 'auto',
                        margin: '0 auto',
                        maxWidth: 250,
                        width: '100%',
                    } }, { children: (0, jsx_runtime_1.jsx)(qrcode_react_1.QRCodeCanvas, { id: "ValeQrcode", size: 250, value: url, includeMargin: true }) })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", mt: 4, spacing: 2, justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(ButtomComponent_1.default, __assign({ variant: "outlined", onClick: function () { return handleCopyUrlQr(); } }, { children: "Copiar Link Vale" })), (0, jsx_runtime_1.jsx)(ButtomComponent_1.default, __assign({ ref: downloadRef, variant: "contained", onClick: function () { return downloadQR(); } }, { children: "Descargar QR" }))] }))] })) })));
}
exports.ModalQrContainer = ModalQrContainer;
